exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:992px){.ocultar[data-v-44a10334]{display:none}}@media (min-width:992px){.ocultar-lg[data-v-44a10334]{display:none}}.border-success[data-v-44a10334]{border:2px solid green}.bg-success-light[data-v-44a10334]{background-color:#d4edda}.border-danger[data-v-44a10334]{border:2px solid red}.bg-danger-light[data-v-44a10334]{background-color:#f8d7da}.hide-elements .no-pdf[data-v-44a10334]{display:none!important}", ""]);

// exports
